import React from "react";

function Friends() {
    return (
        <div>
            <h1>Hang out with your friends in a lobby - Coming Soon!</h1>
        </div>
    );
};

export default Friends;